module.exports = __webpack_public_path__ + "static/media/tabs-icon-list.0310bdb9.svg";